import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForTradePartnerComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'partnerType',
      type: 'selectRelationship',
      recordType: 'category',
      useLocaleFilter: true,
      queryParams: {
        'filter[type]': 'P_TYPE_ONOFF',
        'sort[name]': 'ASC',
      },
    },
    {
      key: 'tradeType',
      type: 'selectRelationship',
      recordType: 'category',
      useLocaleFilter: true,
      queryParams: {
        'filter[type]': 'P_TYPE_TRADE',
        'sort[name]': 'ASC',
      },
    },
    {
      key: 'customFilter',
      type: 'selectCustom',
      options: [{ property: 'chartable', value: 1 }],
    },
  ];

  defaultColumns = [
    'id',
    'name',
    'city',
    'country',
    'partnerType',
    'tradeTypes',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'zipcode',
      sortable: true,
    },
    {
      property: 'city',
      sortable: true,
    },
    {
      property: 'region',
      type: 'relation',
    },
    {
      property: 'country',
      type: 'relation',
    },
    {
      property: 'street',
      sortable: true,
    },
    {
      property: 'partnerType',
      type: 'relation',
    },
    {
      property: 'tradeTypes',
      type: 'relation',
    },
    {
      property: 'link',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
